import classNames from 'classnames';
import type { ReactElement, RefObject } from 'react';
import { useRef, useState } from 'react';
import type { PreviewModeBarProps } from './PreviewModeBar.data';
import styles from './PreviewModeBar.module.scss';
import {
  setupTransitionInTimeline,
  setupTransitionOutTimeline,
} from './PreviewModeBar.transitions';
import { useChangeTransitionState } from 'util/react-transition-component/hooks/useChangeTransitionState';
import { useTransitionController } from 'util/react-transition-component';
import PrimaryLink from '../../atoms/primary-link/PrimaryLink';
import { renderCta } from '../../../util/cta/cta.template';
import Icon from '../../atoms/icon/Icon';

export default function PreviewModeBar({
  isVisible,
  className,
  ref,
}: PreviewModeBarProps): ReactElement {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<HTMLDivElement | null>;
  const [isHidden, setIsHidden] = useState(false);

  const transitionController = useTransitionController(
    () => ({
      ref: elementRef,
      refs: {
        elementRef,
      },
      setupTransitionInTimeline,
      setupTransitionOutTimeline,
    }),
    [],
  );

  const onCloseClick = () => {
    setIsHidden(true);
  };

  useChangeTransitionState(transitionController, isVisible);

  return (
    <div
      ref={elementRef}
      className={classNames(styles.previewModeBar, className, {
        [styles.isHidden]: isHidden,
      })}
    >
      <div className={styles.content}>
        {renderCta({
          innerTemplate: <Icon name="close" className={classNames(styles.icon)} />,
          props: {
            className: classNames(styles.closeButton),
            onClick: onCloseClick,
            'aria-label': 'Click to close',
          },
        })}
        You&apos;re currently in preview mode or (local)developer mode. This content may differ from
        the published.
      </div>
      <PrimaryLink
        link={{ href: '/api/exit-preview', locale: false }}
        label="exit preview-mode"
        textVariant="button-label-large"
        target="_blank"
        className={styles.link}
      />
    </div>
  );
}
